import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Nomor HP tersimpan sebagai `62` + digit lokal (satu bentuk kanonik supaya
 * `users.phone` yang unik tidak bisa membagi satu orang jadi dua akun).
 * Untuk ditampilkan ke user, kembalikan ke format lokal `0812-...` supaya
 * angka yang mereka lihat sama dengan yang mereka ketik.
 */
export function formatPhoneLocal(phone) {
  const digits = String(phone ?? "").replace(/\D/g, "");
  if (!digits.startsWith("62") || digits.length < 10) return phone || "-";
  return ("0" + digits.slice(2)).replace(/(\d{4})(\d{4})(\d+)$/, "$1-$2-$3");
}
